<template>
  <div class="container">

    <heading-one class="-margin-md">暗証番号認証</heading-one>

    <template v-if="Object.keys(errors).length > 0">
      <errors-alert :errors="errors"></errors-alert>

      <form @submit.prevent="submitCheckPincode" novalidate>
        <section>
          <table-group>
            <table-box>
              <table-body>
                <table-row>
                  <table-header>暗証番号</table-header>
                  <table-data :hasError="errors['pincode']">
                    <input-group :errors="errors" :propNames="['pincode']">
                      <inputgroup-append>
                        <input-item v-model="inputPincode.pincode" class="-md" id="confirmCode" type="password" :maxlength="4"></input-item>
                      </inputgroup-append>
                    </input-group>
                  </table-data>
                </table-row>
              </table-body>
            </table-box>
          </table-group>
        </section>

        <btngroup-single class="-margin-lg">
          <btn-main @click.prevent="submitCheckPincode" class="-main">
            認証する
          </btn-main>
        </btngroup-single>

        <btngroup-single class="-margin-lg">
          <btn-main class="-normal" routerName="mb032">
            暗証番号を忘れた方はこちら
          </btn-main>
        </btngroup-single>
      </form>
    </template>

    <template v-else-if="checkPincode.ng_count">
      <template v-if="checkPincode.ng_count < 3">
        <notice-box v-if="checkPincode.ng_count > 0" class="-error _mb-sm-40 _mb-md-60">
          <notice-header>
            <h3 class="heading">以下の内容をご確認ください。</h3>
          </notice-header>
          <notice-body>
            <ul>
              <li>ご入力いただいた暗証番号が違います。ご確認のうえ再度入力してください。</li>
            </ul>
          </notice-body>
        </notice-box>
        <notice-box v-else class="-cancel _mb-sm-40 _mb-md-60">
          <notice-header>
            <h3 class="heading">暗証番号をご入力ください。</h3>
          </notice-header>
        </notice-box>

        <form @submit.prevent="submitCheckPincode" novalidate>
          <section>
            <table-group>
              <table-box>
                <table-body>
                  <table-row>
                    <table-header>暗証番号</table-header>
                    <table-data :hasError="errors['pincode']">
                      <input-group :errors="errors" :propNames="['pincode']">
                        <inputgroup-append>
                          <input-item v-model="inputPincode.pincode" class="-md" id="confirmCode" type="password" :maxlength="4"></input-item>
                        </inputgroup-append>
                      </input-group>
                    </table-data>
                  </table-row>
                </table-body>
              </table-box>
            </table-group>
          </section>

          <btngroup-single class="-margin-lg">
            <btn-main @click.prevent="submitCheckPincode" class="-main">
              認証する
            </btn-main>
          </btngroup-single>

          <btngroup-single class="-margin-lg">
            <btn-main class="-normal" routerName="mb032">
              暗証番号を忘れた方はこちら
            </btn-main>
          </btngroup-single>
        </form>
      </template>

      <template v-else-if="checkPincode.ng_count >= 3">
        <notice-box class="-error _mb-sm-40 _mb-md-60">
          <notice-header>
            <h3 class="heading">以下の内容をご確認ください。</h3>
          </notice-header>
          <notice-body>
            <ul>
              <li>一定回数以上入力の誤りがあったため、暗証番号がロックされました。<br>「暗証番号の再設定へ」を押してロックを解除してください。</li>
            </ul>
          </notice-body>
        </notice-box>

        <btngroup-single class="-margin-lg">
          <btn-main class="-normal" routerName="mb032">
            暗証番号の再設定へ
          </btn-main>
        </btngroup-single>
      </template>

    </template>

  </div><!-- container -->
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { checkPincodeLambdaInvoke, getUserDataLambdaInvoke } from '../utils/LambdaHelper'
import { inputItemsMb } from '../constants/constant'
import errorsAlert from '../components/alert/ErrorsAlert'
import HeadingOne from '../components/heading/HeadingOne'
import TableGroup from '../components/tables/TableGroup'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableData from '../components/tables/TableData'
import TableHeader from '../components/tables/TableHeader'
import InputGroup from '../components/input/InputGroup'
import InputAppend from '../components/input/InputAppend'
import InputItem from '../components/input/InputItem'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import NoticeBody from '../components/box/NoticeBody'
import InputgroupAppend from '../components/input/InputgroupAppend'

export default {
  name: 'Mb-010',
  metaInfo: {
    title: '暗証番号認証',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト'}
    ]
  },
  components: {
    InputgroupAppend,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
    BtnMain,
    BtngroupSingle,
    InputItem,
    InputGroup,
    InputAppend,
    TableGroup,
    TableBox,
    TableBody,
    TableRow,
    TableHeader,
    TableData,
    HeadingOne,
    errorsAlert: errorsAlert
  },
  data () {
    return {
      errors: {},
      isDisabled: false,
      inputPincode: {
        pincode: '',
        auth_kind: this.$route.query.auth_kind
      },
      pageId: this.$route.query.page_id,
      checkPincode: {
        pincode: '',
        message_code: '',
        verification_result: '',
        ng_count: ''
      },
      inputItemsMb: inputItemsMb
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        let pincodeNgcount = res['pincode_ngcount'] || '0'
        if (pincodeNgcount > 2) {
          this.checkPincode.ng_count = pincodeNgcount
        } else {
          this.checkPincode.ng_count = '0'
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    submitCheckPincode: function () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}

        initCredentials().then(res => {
          checkPincodeLambdaInvoke(this.inputPincode).then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else if (res.hasOwnProperty('body')) {
              let resBody = JSON.parse(res.body)
              for (let key in resBody) {
                if (this.checkPincode.hasOwnProperty(key)) {
                  this.checkPincode[key] = resBody[key]
                }
              }
              if (this.checkPincode.verification_result === 'true') {
                let pageName = this.pageId.toLowerCase().replace('-', '')
                this.$router.push({name: pageName})
              } else {
                // this.checkPincode.ng_count の値でメッセージを表示する
                this.scrollTop()
                this.isDisabled = false
              }
            } else {
              this.$router.push({name: 'SessionTimeOut'})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Mb010.vue